import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ASSESSMENTPOPUP_URL } from "../service/data";

const initialState = {
  assessmentPopupData: {},
  accessToken: null,
  loading: false,
  error: null,
  success: false,
};

export const assessmentPopupCall = createAsyncThunk(
  "assessmentPopup/assessmentPopupCall",
  async (accessToken, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          // Authorization: accessToken ? `Bearer ${accessToken}` : "",
          "x-api-key": process.env.REACT_APP_API_KEY,
        },
      };
      const response = await axios.get(ASSESSMENTPOPUP_URL, config);

      return response;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const assessmentPopupSlice = createSlice({
  name: "assessmentPopup",
  initialState,
  reducers: {
    setAssessmentPopUp: (state, action) => {
      state.assessmentData = action.payload;
    },
  },
  extraReducers: {
    [assessmentPopupCall.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [assessmentPopupCall.fulfilled]: (state, action) => {
      state.loading = false;
      state.success = true;
      state.assessmentPopupData = action.payload.data;
    },
    [assessmentPopupCall.rejected]: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    },
  },
});

export const { setAssessmentPopUp } = assessmentPopupSlice.actions;

export default assessmentPopupSlice.reducer;
